var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.organizationInfo.app ? _vm.organizationInfo.app.dark : false}},[_c('app-left-menu'),_vm._v(" "),_c('app-top-menu'),_vm._v(" "),(_vm.organizationInfo.parallax && _vm.organizationInfo.parallax.enabled)?[_c('app-parallax',{attrs:{"data":_vm.organizationInfo.parallax}})]:_vm._e(),_vm._v(" "),_c('app-content')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c12b48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 